import React, { useState } from 'react'

export default function OtpStep({ email, loading, error, onSubmit, onBack }) {
  const [otp, setOtp] = useState('')
  const [localError, setLocalError] = useState('')

  function handleSubmit(e) {
    e.preventDefault()
    if (otp.trim().length !== 6) {
      setLocalError('Inlogcode moet 6 cijfers zijn')
      return
    }
    setLocalError('')
    onSubmit(otp.trim())
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="bg-blue-50 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-800 rounded-md p-4">
        <p className="text-sm text-blue-700 dark:text-blue-300">
          We hebben een inlogcode verstuurd naar <strong>{email}</strong>
        </p>
      </div>
      <div>
        <label htmlFor="otp" className="form-label">Inlogcode (6 cijfers)</label>
        <input
          id="otp"
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          value={otp}
          onChange={(e) => {
            setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))
            setLocalError('')
          }}
          className={`form-input text-center text-2xl tracking-widest ${(localError || error) ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : ''}`}
          placeholder="000000"
          maxLength={6}
          disabled={loading}
          autoFocus
        />
        {(localError || error) && (
          <p className="mt-1 text-sm text-red-600 dark:text-red-400">{localError || error}</p>
        )}
      </div>
      <div className="flex flex-col space-y-3">
        <button type="submit" className="btn btn-primary w-full text-lg py-3" disabled={loading}>
          {loading ? (
            <span className="flex items-center justify-center space-x-2">
              <span className="animate-spin rounded-full h-5 w-5 border-b-2 border-white" />
              <span>Inloggen...</span>
            </span>
          ) : 'Inloggen'}
        </button>
        <button type="button" onClick={onBack} className="btn btn-outline w-full" disabled={loading}>
          Ander emailadres gebruiken
        </button>
      </div>
    </form>
  )
}
